/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostWithdrawalSecretsMutationRequest,
  PostWithdrawalSecretsMutationResponse,
  PostWithdrawalSecrets400,
  PostWithdrawalSecrets403,
} from '../entities/PostWithdrawalSecrets'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostWithdrawalSecretsUrl() {
  return `/withdrawal-secrets` as const
}

/**
 * @description Создание api-ключа вывода средств для таксопарка
 * @summary Создание api-ключа вывода средств для таксопарка
 * {@link /withdrawal-secrets}
 */
export async function postWithdrawalSecrets(
  data: PostWithdrawalSecretsMutationRequest,
  config: Partial<RequestConfig<PostWithdrawalSecretsMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    PostWithdrawalSecretsMutationResponse,
    ResponseErrorConfig<PostWithdrawalSecrets400 | PostWithdrawalSecrets403>,
    PostWithdrawalSecretsMutationRequest
  >({ method: 'POST', url: getPostWithdrawalSecretsUrl().toString(), data, ...requestConfig })
  return res.data
}